module.exports = __webpack_public_path__ + "static/img/banner20.a69d58fa.png";